<div class="container p-5">
    <button type="button" class="btn btn-primary" (click)="addToast()">Test toast</button>
</div>